module.exports = __webpack_public_path__ + "img/icon_wxwg.6b0e3517.png";